import React, { useState } from "react";
import Blog from "@/pages/Blog";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";

const NewsletterSignupCard = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email");
    setSubmitting(true);
    try {
      await subscribeNewsletter({ email, name, source: "newsletter_page" });
      setDone(true);
      toast.success("You're subscribed. Watch your inbox.");
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "newsletter_signup", { source: "newsletter_page" });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Subscription failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="mt-8 max-w-lg bg-white border border-[#E8DCDD] rounded-md p-6"
        data-testid="newsletter-signup-success">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#3F7A4F] mb-2">Subscribed ✓</div>
        <p className="text-sm text-[#4A3E42] leading-relaxed">
          Welcome. Watch your inbox for the next dispatch. If you don't see it in the next few minutes,
          check spam and mark us as safe.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-signup-form"
      className="mt-8 max-w-lg bg-white border border-[#E8DCDD] rounded-md p-6 space-y-3">
      <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57]">Subscribe</div>
      <p className="text-sm text-[#4A3E42] leading-relaxed">
        Get every dispatch delivered — practical leadership writing, no spam. Unsubscribe anytime.
      </p>
      <input type="text" value={name} onChange={(e) => setName(e.target.value)}
        placeholder="First name (optional)" data-testid="newsletter-signup-name"
        className="w-full px-3 py-2.5 border border-[#E8DCDD] rounded-sm text-sm focus:outline-none focus:border-[#8C4A57]" />
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address" required data-testid="newsletter-signup-email"
        className="w-full px-3 py-2.5 border border-[#E8DCDD] rounded-sm text-sm focus:outline-none focus:border-[#8C4A57]" />
      <button type="submit" disabled={submitting} data-testid="newsletter-signup-submit"
        className="w-full bg-[#8C4A57] text-white py-2.5 rounded-sm hover:bg-[#6f3945] disabled:opacity-60 uppercase text-xs tracking-widest font-semibold">
        {submitting ? "Subscribing…" : "Subscribe"}
      </button>
    </form>
  );
};

const Newsletter = () => (
  <Blog
    apiPath="/newsletter/posts"
    basePath="/newsletter"
    kicker="Dispatches"
    heading="The Global Leader Newsletter"
    intro="Occasional dispatches from Dr. Andrew Campbell on character-based leadership, emotional intelligence, and constructive conflict engagement — straight from his desk."
    metaTitle="Newsletter — Global Leader Solutions"
    metaDescription="Occasional dispatches on character-based leadership, emotional intelligence, and conflict management from Dr. Andrew Campbell."
    emptyLabel="The first newsletter is on its way — subscribe above to be the first to know."
    testIdPrefix="newsletter"
    heroCta={<NewsletterSignupCard />}
  />
);

export default Newsletter;
